import { LANGUAGES } from 'config/constants/languages'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { getIcon, Icons } from 'svgs'
import colors from 'theme/ui/colors'
import Flex from 'UIKit/Box/Flex'
import { FlexProps } from 'UIKit/Box/types'
import Text from 'UIKit/Text'
import { useOpenLanguageSelectModal } from './hooks'

interface LanguageSelectProps extends FlexProps {
  small?: boolean
}

const LanguageSelect: React.FC<LanguageSelectProps> = ({ small, ...props }) => {
  const { i18n } = useTranslation()
  const { handlePresentLanguageSelectModal } = useOpenLanguageSelectModal()

  const selectedLanguage = useMemo(
    () => LANGUAGES.find((item) => item.code.toLowerCase() === i18n.language?.toLowerCase()),
    [i18n.language],
  )
  const Logo = getIcon(selectedLanguage?.logo)
  return (
    <StyledLangugeSelected
      id={'language-selected'}
      $Small={small}
      alignItems="center"
      onClick={handlePresentLanguageSelectModal}
      {...props}
    >
      <Logo />
      <Text bold margin={small ? '4px 0px 0px 0px' : '0px 0px 0px 8px'} color="textSubtle" fontSize="14px">
        {i18n.language?.substring(0, 2).toLocaleUpperCase()}
      </Text>
      {!small && <Icons.ArrowDownIcon fill={colors.textSubtle} />}
    </StyledLangugeSelected>
  )
}

const StyledLangugeSelected = styled(Flex)<{ $Small?: boolean }>`
  flex-direction: ${({ $Small }) => ($Small ? 'column' : 'row')};
  padding-left: ${({ $Small }) => ($Small ? '0px' : '24px')};
  width: 100%;
  height: 100%;
  justify-content: ${({ $Small }) => ($Small ? 'center' : 'flex-start')};
`

export default LanguageSelect
